import { render, staticRenderFns } from "./pagination.component.html?vue&type=template&id=43fbd403&scoped=true&external"
import script from "./pagination.component.vue?vue&type=script&lang=ts"
export * from "./pagination.component.vue?vue&type=script&lang=ts"
import style0 from "./pagination.component.css?vue&type=style&index=0&id=43fbd403&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fbd403",
  null
  
)

export default component.exports